import { getUserSession } from '@/service/UserService.js'
import { useKinectinStore } from '@/store/kinectin.js'
import { storeToRefs } from 'pinia'
import { linkIdToId } from '@/service/uiUtils.js'

const unauthenticatedRoutes = [
    'signin',
    'signup',
    'signupwith-orgUrlSegment',
    'signinwith-orgUrlSegment',
    'privacy',
    'terms',
    'about',
    'auth_callback',
    'berightback',
]
const webAppHideDrawerRoutes = ['onboard', ...unauthenticatedRoutes]
const nativeAppHideDrawerRoutes = ['onboard', ...unauthenticatedRoutes]

function setupRouterMiddleware({ router }) {
    router.beforeEach(async (to, from, next) => {
        if (['berightback', 'privacy', 'terms', 'about', 'auth_callback'].includes(to.name)) return next()

        const store = useKinectinStore()
        const { maintenanceMode, userIsAuthenticated } = storeToRefs(store)

        if (maintenanceMode.value) return next({ path: '/berightback', query: { redirect: to.fullPath } })

        if (to.name === 'signinwith-orgUrlSegment') { // special handling here
            const { token } = await getUserSession()
            if (token) return next(to.query.redirect)
        }

        let title = to.path === '/' ? 'Kinectin' : `Kinectin - ${to.path}`
        if (unauthenticatedRoutes.includes(to.name)) {
            document.title = title
            return next()
        }
        const { token } = await getUserSession()
        if (!token) {
            await store.clearCoachGreet() // in case a different user logs in
            if (['signupwith-orgUrlSegment', 'signinwith-orgUrlSegment'].includes(to.name)) {
                return next()
            }
            return next({ path: '/signin', query: { redirect: to.fullPath } })
        }
        userIsAuthenticated.value = true

        await store.loadUserProfile()
        const fnsByRouteName = {
            'orgs': store.userCanManageOrgIds,
            'org-orgId': store.userCanManageOrgIds,
        }
        const fn = fnsByRouteName[to.name]
        if (fn && !fn()) return next({ path: '/chat/new' })

        if (to.name === 'chat-threadId' && to.path !== '/chat/new') {
            const linkId = to.params.threadId
            const threadId = linkIdToId({ linkId })
            await store.selectThread({ threadId })
            const { selectedThread } = storeToRefs(store)
            title = `Kinectin - ${selectedThread.value.name}`
        }
        document.title = title
        return next()
    })
}

export {
    setupRouterMiddleware,
    unauthenticatedRoutes,
    webAppHideDrawerRoutes,
    nativeAppHideDrawerRoutes,
}